"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSampleAddressForCountry = void 0;
const country_1 = require("../enums/country");
const SAMPLE_ADDRESS_BY_COUNTRY = {
    [country_1.OrganizationCountry.Australia]: {
        country: country_1.CountryCode.AU,
        city: "Sydney",
        postalCode: "2000",
        address: "1 George Street",
        userTimezone: "Australia/Sydney",
        phoneNumber: "+61 2 9374 4000",
    },
    [country_1.OrganizationCountry.GreatBritain]: {
        country: country_1.CountryCode.GB,
        city: "London",
        postalCode: "SW1A 1AA",
        address: "10 Downing Street",
        userTimezone: "Europe/London",
        phoneNumber: "+44 20 7946 0958",
    },
    [country_1.OrganizationCountry.Canada]: {
        country: country_1.CountryCode.CA,
        city: "Montreal",
        postalCode: "H3B 0G4",
        address: "1250 René-Lévesque Blvd W",
        userTimezone: "America/Toronto",
        phoneNumber: "+1 (514) 555-1234",
    },
    [country_1.OrganizationCountry.Ireland]: {
        country: country_1.CountryCode.IE,
        city: "Dublin",
        postalCode: "D02 AF30",
        address: "1 Grand Canal Square",
        userTimezone: "Europe/Dublin",
        phoneNumber: "+353 1 234 5678",
    },
    [country_1.OrganizationCountry.Germany]: {
        country: country_1.CountryCode.DE,
        city: "Berlin",
        postalCode: "10115",
        address: "Invalidenstraße 116",
        userTimezone: "Europe/Berlin",
        phoneNumber: "+49 30 123456",
    },
};
const DEFAULT_SAMPLE_ADDRESS = {
    country: country_1.CountryCode.US,
    city: "New York",
    postalCode: "10023",
    address: "164 W 75th St.",
    userTimezone: "America/New_York",
    phoneNumber: "+1 (202) 555-1234",
};
const getSampleAddressForCountry = (country) => {
    if (!country) {
        return DEFAULT_SAMPLE_ADDRESS;
    }
    return SAMPLE_ADDRESS_BY_COUNTRY[country] ?? DEFAULT_SAMPLE_ADDRESS;
};
exports.getSampleAddressForCountry = getSampleAddressForCountry;
